var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 9.675V12.825C12.5 15.45 11.45 16.5 8.825 16.5H5.675C3.05 16.5 2 15.45 2 12.825V9.675C2 7.05 3.05 6 5.675 6H8.825C11.45 6 12.5 7.05 12.5 9.675Z",
    stroke: "#736F89",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 5.175V8.325C17 10.95 15.95 12 13.325 12H12.5V9.675C12.5 7.05 11.45 6 8.825 6H6.5V5.175C6.5 2.55 7.55 1.5 10.175 1.5H13.325C15.95 1.5 17 2.55 17 5.175Z",
    stroke: "#736F89",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.a2a2bcdf54f477045d5cde9b9059b03a.svg";
export { ForwardRef as ReactComponent };